export function SourceCellAg(props: { value: string }) {
  switch (props.value) {
    case 'GOOGLE_DRIVE_SYNC':
      return (
        <>
          <span className="flex bq-badge-info bq-badge align-items-center gap-1">
            <i className="pi pi-cloud-upload" style={{ fontSize: '1rem' }}></i>
            G-drive-sync
          </span>
        </>
      );
    case 'GOOGLE_DRIVE':
      return (
        <>
          <span className="flex bq-badge-info bq-badge align-items-center gap-1">
            <i className="pi pi-google" style={{ fontSize: '1rem' }}></i>
            G-drive
          </span>
        </>
      );
    case 'MANUAL':
      return (
        <>
          <span className="flex bq-badge-info bq-badge align-items-center gap-1">
            <i className="pi pi-folder" style={{ fontSize: '1rem' }}></i>
            Local folder
          </span>
        </>
      );
    default:
      return (
        <>
          <span className="flex bq-badge-info bq-badge align-items-center gap-1">
            <i className="pi pi-folder" style={{ fontSize: '1rem' }}></i>
            Local folder
          </span>
        </>
      );
  }
}
